import React, {useContext, useEffect} from 'react'
import Autocomplete from '@material-ui/lab/Autocomplete'
import FormControl from '@material-ui/core/FormControl'
import {TextField, Grid} from '@material-ui/core'
import LikeNotLike from './LikeNotLike'
import {ReservationConfigurationContext} from '../../../context/ReservationConfiguration'
import {normalizeFieldValues} from '../../ReservationReserve/FieldFilter/util'
import _ from 'lodash'
export default function MultipleFieldSelect({
  fieldType,
  onChange = (e, key, value, typeId) => {},
  idx,
  data,
  fieldData,
  filterFieldValues,
}) {
  const listData = normalizeFieldValues(fieldType.type, filterFieldValues)

  const getSelected = () => {
    let selectedData = []
    if (data?.fix_value && data?.fix_value !== '') {
      if (Array.isArray(data?.fix_value)) {
        const intValues = data.fix_value.map(value => value)
        selectedData = listData.filter(template => {
          return intValues.includes(template.value)
        })
      }
    }
    return selectedData
  }

  const fieldValues = () => {
    let fieldValues = []
    if (!_.isEmpty(fieldData?.fix_value)) {
      fieldValues = fieldData?.fix_value
    }
    if (Array.isArray(fieldValues)) {
      fieldValues = fieldValues?.flat()
    }
    return fieldValues
  }

  const getOptionsData = () => {
    let optionsValues = []
    const selectedArr = getSelected().map(val => val.value)
    const fixValArr = [...fieldValues(), ...selectedArr].flat()
    optionsValues = listData.filter(data => !fixValArr.includes(data.value))

    return optionsValues
  }

  const firstFieldValue = fieldValues()[0]
  const isNumber = typeof firstFieldValue === 'number'

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <LikeNotLike type={fieldType} onChange={onChange} idx={idx} data={data} />
      </Grid>
      <Grid item xs={8}>
        <FormControl variant="outlined" style={{width: '100%'}}>
          <Autocomplete
            multiple
            className="autoComplete"
            options={getOptionsData()}
            loading={true}
            getOptionLabel={option => option.label}
            name="select"
            value={listData.filter(d =>
              fieldValues().includes(isNumber ? d.value : String(d.value))
            )}
            filterSelectedOptions
            defaultValue={getSelected()}
            onChange={(e, value) => {
              const fix_value = value.map(val => {
                return val.value
              })
              onChange(e, 'list_filters_attributes', fix_value, 'fix_value', idx, '', fieldType.id)
            }}
            renderInput={params => (
              <TextField
                {...params}
                variant="outlined"
                label="Type to Search"
                placeholder="Type to Search"
              />
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  )
}
